import {UserType} from '@legit.health/ui';
import {CurrentPractitioner} from '@/practitioner/interfaces/Practitioner';
import {CurrentUserBase} from '@/shared/contexts/UserContext';

export default function isCurrentPractitioner(user: CurrentUserBase): user is CurrentPractitioner {
  return user.type === UserType.Practitioner;
}
